module.exports = require("to-arraybuffer");